import { Chat } from "@/types";

import { axios } from "../axios.instance";

export type GetChatsRequest = {
  perPage?: number;
  cursor?: string;
  isArchived?: boolean;
};

export type GetChatsResponse = {
  data: Chat[];
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getChats = async (params: GetChatsRequest): Promise<GetChatsResponse> => {
  const { data } = await axios.get(`/chats`, {
    params,
  });

  return data;
};
